import { NgModule } from '@angular/core';
import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { TamasAlunoService } from '../tamas-aluno.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AlertaSimplesDialog } from '../alerta-simples';
import { AlertaInputDialog } from '../alerta-input';
import { AlertaConfirmDialog } from '../alerta-confirm';
import { Location } from '@angular/common';
//import { DatePipe } from '@angular/common';
import { AlertaTermosDialog } from '../alerta-termos';

@Component({
  selector: 'app-recuperar-senha',
  templateUrl: './recuperar-senha.component.html',
  styleUrls: ['./recuperar-senha.component.css']
})
export class RecuperarSenhaComponent implements OnInit {

  @ViewChild("nomeInput") nomeInput: ElementRef;
  @ViewChild("nascimentoInput") nascimentoInput: ElementRef;
  @ViewChild("celularInput") celularInput: ElementRef;
  @ViewChild("emailInput") emailInput: ElementRef;
  @ViewChild("emailconfInput") emailconfInput: ElementRef;

  nome: any = '';
  email: any = '';
  emailconf: any = '';
  senha: any = '';
  nascimento: string = '';
  celular: string = '';
  newsletter: boolean = true;
  shouldHide: boolean = true;
  shouldHide1: boolean = false;
  shouldHide2: boolean = true;
  shouldHide3: boolean = true;
  nomeCliente: any = '';
  hideLoginLoad: boolean = true;
  meusDados: any = '';
  dadosRecuperar: any = '';
  tentativasFail: any = 0;
  isPassword: boolean = true;
  idCliente: any = 0;
  fcmToken: any = '';

  emailrs: any = '';
  codigors: any = '';
  public maskNascimento = [/[0-9]/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  public maskTelefone = ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  constructor(private route: ActivatedRoute, public tmaService: TamasAlunoService, public router: Router, public dialog: MatDialog, private _location: Location /*private piData: DatePipe*/) { }

  ngOnInit() {
    this.tmaService.eventoFS(true);
    this.emailrs = this.route.snapshot.paramMap.get('email');
    this.codigors = this.route.snapshot.paramMap.get('codigo');
    this.hideLoginLoad = true;
  }
  ngOnDestroy() {
    console.log("destroy");
    this.tmaService.eventoFS(false);
  }

  togglePW(): void {
    this.isPassword = !this.isPassword;
    console.log(this.isPassword);
  }


  changePW(): void {

    if (this.senha.length < 6) {
      const senhaInsuf = this.dialog.open(AlertaSimplesDialog, {
        data: { textoAlerta: "Sua senha deve ter pelo menos 6 digitos" }
      });
      return;
    }

    //this.hideLoginLoad = false;


    let postParams = {
      email: this.emailrs,
      codigo: this.codigors,
      novasenha: this.senha
    }

    console.log("Stringify");
    //console.log(JSON.stringify(postParams));
    //console.log("Encoded");
    //console.log(encodeURIComponent(JSON.stringify(postParams)));
    //console.log(localStorage.getItem('turboCart'));
    this.hideLoginLoad = false;
    this.tmaService.alterarSenha(postParams)
      .subscribe((qRes) => {
        this.hideLoginLoad = true;
        if (qRes['res'] == 'done') {
          const senhaOK = this.dialog.open(AlertaConfirmDialog, {
            disableClose: true,
            data: { tituloAlerta: "Pronto!", textoAlerta: "Sua senha foi alterada com sucesso, agora você pode efetuar o login normalmente", textoConfirm: "OK" }
          });
          senhaOK.afterClosed().subscribe(resultInp => {
            //limpar dados de login anterior e redirecionar
            this.router.navigate(['/login']);
          });
        }
        else{
          if(qRes['res'] == 'expired'){
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose: true,
              data: { textoAlerta: "O período para alterar a senha expirou. Enviamos um novo link de alteração de senha para seu e-mail.", iconAlerta: 'warning' }
            });
          }
          else{
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose: true,
              data: { textoAlerta: "Não foi possível alterar sua senha. Clique no link enviado para o e-mail e tente novamente", iconAlerta: 'warning' }
            });
          }
        }
      },
        (error) => {
          this.hideLoginLoad = true;
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
          });
        })




  }





  // recuperarPass(): void{
  //     var fraseRecuperar = "";
  //     fraseRecuperar = "Insira abaixo o seu e-mail que nós enviaremos a senha"

  //     const dialogRecuperarP = this.dialog.open(AlertaInputDialog, {
  //         disableClose: true,
  //         width: '300px',
  //         data: {tituloAlerta: "Esqueceu sua senha" , textoAlerta: fraseRecuperar , textoInput: "E-mail", tipoInput: "email", valorInput: this.email, textoCancel: "Cancelar", textoConfirm: "Confirmar"}
  //       });
  //       dialogRecuperarP.afterClosed().subscribe(resultInp =>{
  //         console.log('The dialog was closed');
  //         console.log(resultInp);
  //         if (resultInp == false){
  //             return;
  //         }
  //         if (resultInp == ''){
  //             //false
  //             const emailNulo = this.dialog.open(AlertaSimplesDialog, {
  //                 width: '250px',
  //                 data: {textoAlerta: "Você deve digitar um e-mail válido para recuperar sua senha!"}
  //             });
  //             console.log("E-mail inválido");
  //             return;
  //         }
  //         else{
  //             //faz a chamada para recuperar a senha
  //             this.dadosRecuperar = "email=" + resultInp;
  //             this.hideLoginLoad = false;
  //             this.tmaService.getRecuperar(this.dadosRecuperar)
  //             .subscribe((qRec) =>{
  //                 console.log(qRec);
  //                 if (qRec['res'] == 'invalid'){
  //                     const algoErrado3 = this.dialog.open(AlertaSimplesDialog, {
  //                         width: '250px',
  //                         data: {textoAlerta: "E-mail não encontrado no sistema!"}
  //                     });
  //                 }
  //                 if (qRec['res'] == 'done'){
  //                     const recDone = this.dialog.open(AlertaSimplesDialog, {
  //                         width: '250px',
  //                         data: {textoAlerta: "Em instantes você receberá a senha no e-mail informado"}
  //                     });
  //                 }
  //                 this.hideLoginLoad = true;
  //             });

  //         }

  //       });
  // }

  voltar(): void {
    //this._location.back();
    this.router.navigate(['/login']);
  }

  openTermos() {
    const dialogRef = this.dialog.open(AlertaTermosDialog, { autoFocus: false });
    // dialogRef.afterClosed().subscribe(result => {
    //   console.log(`Dialog result: ${result}`);
    // });
  }
}